import { MedicalBookingCard } from '@conexasaude/conexa-hero'
import { Fragment, FunctionComponent } from 'react'
import { ProfessionalCardProps } from './ProfessionalBookingCard.types'
import { useProfessionalBookingCard } from './ProfessionalBookingCard.hook'
import RenderIf from '@/components/RenderIf'
import { SummaryAppointment } from '@/modules/Telemedicine/components/modal/SummaryAppointment'

const ProfessionalBookingCard: FunctionComponent<ProfessionalCardProps> = ({
  professional,
  startDateSlot,
}) => {
  const {
    data,
    selectedDateSlot,
    contentObject,
    modalOpen,
    isLoading,
    handleConfirmShchedule,
    handlePreviousDateChange,
    handleCloseModal,
    renderProfessionalDetails,
    handleNextDateChange,
  } = useProfessionalBookingCard({
    professional,
    startDateSlot,
  })

  return (
    <Fragment>
      <MedicalBookingCard
        professional={renderProfessionalDetails(professional)}
        callbacks={{
          nextStep: handleNextDateChange,
          prevStep: handlePreviousDateChange,
          onConfirm: handleConfirmShchedule,
        }}
        schedule={data || []}
        loading={{
          schedule: isLoading,
        }}
      />

      <RenderIf
        condition={selectedDateSlot && modalOpen === 'SCHEDULE_APPOINTMENT'}
      >
        <SummaryAppointment
          id="SCHEDULE_APPOINTMENT"
          summaryData={contentObject}
          onCloseModal={handleCloseModal}
        />
      </RenderIf>
    </Fragment>
  )
}

export default ProfessionalBookingCard
